import { render, staticRenderFns } from "./EsqueciASenha.vue?vue&type=template&id=5ca7b4e8&scoped=true&"
import script from "./EsqueciASenha.vue?vue&type=script&lang=js&"
export * from "./EsqueciASenha.vue?vue&type=script&lang=js&"
import style0 from "@/components/auth/auth-form.css?vue&type=style&index=0&id=5ca7b4e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca7b4e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
